/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the error of the confirmed order
 * @param {any} state The state management `state`
 * @returns {any} The error while trying to confirm the order which has been selected from the store
 */
const orderConfirmationErrorSelector = createSelector(ordersSelector, (orders) => orders.orderConfirmationError);

export default orderConfirmationErrorSelector;
